import { axios } from 'cm'
import qs from 'qs'
import { getRequestSign } from '../../../../src/frontend-lib/tools/platformSign'
// import {
//   getRunTime
// } from '../../../../src/jslibs/utils'
import { getPlatform } from '../../../../src/frontend-lib/tools/getPlatform'

let platform = getPlatform()

let paramsPlatform = {
  _version: platform.isYixinliApp ? platform.yixinliAPPVersion : '6.3.0',
  _platform: platform.isAndroid
    ? 'android'
    : platform.isiPhone | platform.isiPad
    ? 'ios'
    : 'ios'
}

/*
 * 生成函数的方法
 * */
let funFactory = (api, method = 'get') => params => {
  let allParams = Object.assign({}, paramsPlatform, params)
  console.log('allParams', allParams)
  let { sign, params: paramsWithTimestamp } = getRequestSign(allParams)
  let sendParams = {
    sign,
    ...paramsWithTimestamp
  }
  if (method == 'post') {
    sendParams = qs.stringify(sendParams)
  } else {
    sendParams = {
      params: sendParams
    }
  }
  return axios[method](api, sendParams).then(res => {
    console.log('res.data', res.data)
    return res.data
  })
}

module.exports = {
  funFactory
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/axios/requestSign.js